import { convertCentsToDollars } from './convert-cents-to-dollars.ts'
import { convertDollarsToCents } from './convert-dollars-to-cents.ts'

/**
 * WARNING: DO NOT MODIFY THIS FUNCTION - DOING SO WILL MODIFY APPROVED PROJECT PRICES
 *
 * Calculates the selling price needed to achieve a target profit margin percentage on the given cost.
 *
 * Example: given cost=1000 and margin=50, the result is 2000
 * (I need to charge $2000 to achieve a 50% profit margin on my $1000 cost)
 *
 * @param cost the base cost
 * @param marginPercent a number between 0-99 representing the target profit margin percentage
 * @returns the selling price needed to achieve the target margin percentage
 */
export const calculateCostPlusMargin = (
  cost: number,
  marginPercent: number
) => {
  const costInCents = Math.max(convertDollarsToCents(cost), 0)
  const percent = Math.min(Math.max(marginPercent, 0), 99) / 100
  return Math.round(convertCentsToDollars(costInCents / (1 - percent)))
}
